class FsAccordionSingle extends HTMLElement {
  constructor() {
    super()

    this.elDetails = this.querySelector('details')
    this.elContent = this.querySelector('.fs-accordion__content')
    this.elContentInner = this.querySelector('.fs-accordion__content__inner')

    this.mm = gsap.matchMedia()

    this.addEventListeners()
  }

  addEventListeners() {
    const elSummary = this.querySelector('summary')
    elSummary.addEventListener('click', (e) => {
      this.mm.add('(prefers-reduced-motion: no-preference)', () => {
        e.preventDefault()
        this.toggle()
      })
    })
  }

  async toggle() {
    const isOpen = this.querySelector('details').open

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  async close() {
    const height = this.elContent.scrollHeight
    await gsap.timeline({ defaults: { ease: 'sine.inOut' } })
      .fromTo(this.elContentInner, { opacity: 1 }, { opacity: 0, duration: 0.3 })
      .fromTo(this.elContent, { height }, { height: 0, duration: 0.5 }, '<')
      .set([this.elContent, this.elContentInner], { clearProps: true })

    this.elDetails.open = false
  }

  open() {
    this.elDetails.open = true
    const height = this.elContent.scrollHeight

    gsap.timeline({ defaults: { duration: 0.5, ease: 'sine.inOut' } })
      .fromTo(this.elContent, { height: 0 }, { height, ease: 'sine.inOut' })
      .fromTo(this.elContentInner, { opacity: 0 }, { opacity: 1 }, '-=0.3')
      .set([this.elContent, this.elContentInner], { clearProps: true })
  }
}

if (!customElements.get('fs-accordion-single')) {
  customElements.define('fs-accordion-single', FsAccordionSingle)
}
